import axios from "axios";

import { getToken } from "../utils/AuthService";

const url = process.env.REACT_APP_PINEAPPLE_API_BACKEND_SERVER;

/**
 * @function voucherListService
 * @param
 * @description This function is used to get all voucher item
 */

export const voucherListService = async ({ productIds, amount }) => {
  try {
    const tokens = getToken();
    const { tokenAccess, foodAccessToken } = tokens;
    const result = await axios.get(
      `${url}/vouchers/manage/list?filter=&productIds=${productIds}&amount=${amount}`,
      {
        headers: {
          Authorization: `Bearer ${tokenAccess}`,
          foodauthtoken: `${foodAccessToken}`,
        },
      }
    );
    return result;
  } catch (err) {
    return err;
  }
};

/**
 * @function getVoucherList
 * @param {Object} params - Parameters object
 * @param {string} params.type - Type of vouchers to fetch: 'available', 'claimed', or 'used'
 * @param {string} params.filter - Optional filter string (default: empty string)
 * @description This function is used to get user-side voucher list based on type (available, claimed, used)
 */
export const getVoucherList = async ({
  type = "available",
  filter = "",
  amount,
  productIds,
  vendorId,
  limit=100,
  page
}) => {
  try {
    const tokens = getToken();
    const { tokenAccess, foodAccessToken } = tokens;

    // Build query params dynamically
    const params = new URLSearchParams();

    params.append("type", type);
    params.append("filter", filter);
    params.append("limit", limit);
    params.append("page", page);

    if (amount) params.append("amount", amount);
    if (productIds?.length) params.append("productIds", productIds.join(","));
    if (vendorId?.length) params.append("vendorId", vendorId);

    const result = await axios.get(
      `${url}/vouchers/manage/listUserSide?${params.toString()}`,
      {
        headers: {
          Authorization: `Bearer ${tokenAccess}`,
          foodauthtoken: `${foodAccessToken}`,
        },
      }
    );

    return result;
  } catch (err) {
    return err;
  }
};


/**
 * @function claimVoucher
 * @param {Object} params - Parameters object
 * @param {string|number} params.id - Voucher ID to claim
 * @description This function is used to claim a voucher by ID using PATCH method
 */
export const claimVoucher = async ({ id }) => {
  try {
    const tokens = getToken();
    const { tokenAccess, foodAccessToken } = tokens;
    const result = await axios.patch(
      `${url}/vouchers/manage/claim?id=${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${tokenAccess}`,
          foodauthtoken: `${foodAccessToken}`,
        },
      }
    );
    return result;
  } catch (err) {
    return err;
  }
};